// extracted by mini-css-extract-plugin
export default {"root":"addStaffForm_root__wfpfz","item":"addStaffForm_item__ZhUuu"};